import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-economics',
  templateUrl: './economics.component.html',
  styleUrls: ['./economics.component.scss']
})
export class EconomicsComponent implements OnInit {
  constructor() { }
  ngOnInit(): void { }
}
